import {
  PARAM_PHONE_NUMBER,
  PARAM_IS_EMBEDDED_VIEW,
  PARAM_SHOW_BANNER_IN_EMBEDDED_VIEW,
  PARAM_SHOW_PHONE_INPUT
} from '../constants/params'
import { PARAM_APIKEY } from '../constants/params'
import { PARAM_IS_HEADER_MINI_APP } from '../constants/params'
import { PARAM_IS_HEADER_MINI_APP_EXPAND } from '../constants/params'
import { PARAM_APP_THEME_NAME, PARAM_IS_SELECT_VEHICLE_TYPE_USE_ICON, PARAM_IS_TBPN_SELECT_VEHICLE_TYPE_WITH_ELECTRIC_MOTOBIKE, PARAM_PARTNER_NAME } from '../constants/params'
import { SessionStorageManager } from '../helper/localStorage'
import { smartParseParam } from '../helper/params'
import { getUrlParamValue } from '../helper/params'
import React from 'react'
export const AppParamsContext = React.createContext(null)

const resolveParamsMiniApp = (config) => {
  // 1. param (raw)
  const param = getUrlParamValue(config.paramKey)

  // có param thì lưu session (raw)
  if (param !== null && param !== undefined) {
    SessionStorageManager.setItem(config.storageKey, param)
  }

  // 2. resolve raw theo thứ tự ưu tiên
  const raw = param ?? SessionStorageManager.getItem(config.storageKey) ?? smartParseParam(process.env?.[config.envKey]) ?? config.defaultValue

  // 3. parse giá trị cuối cùng
  return config.parser ? config.parser(raw) : raw
}

/* =====================
 * PARAM MINI APP SCHEMA
 * ===================== */
const PARAMS_MINIAPP_SCHEMA = {
  apikey: {
    paramKey: PARAM_APIKEY,
    storageKey: PARAM_APIKEY,
    envKey: 'REACT_APP_APIKEY',
    defaultValue: undefined,
    parser: (v) => v
  },
  sdkPhoneNumber: {
    paramKey: PARAM_PHONE_NUMBER,
    storageKey: PARAM_PHONE_NUMBER,
    envKey: undefined,
    defaultValue: '',
    parser: (v) => v
  },
  isEmbeddedView: {
    paramKey: PARAM_IS_EMBEDDED_VIEW,
    storageKey: PARAM_IS_EMBEDDED_VIEW,
    envKey: 'REACT_APP_PARAM_IS_EMBEDDED_VIEW',
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  isHeaderMiniApp: {
    paramKey: PARAM_IS_HEADER_MINI_APP,
    storageKey: PARAM_IS_HEADER_MINI_APP,
    envKey: 'REACT_APP_PARAM_IS_HEADER_MINI_APP',
    defaultValue: undefined,
    parser: (v) => v === true || v === 1
  },
  isHeaderMiniAppExpand: {
    paramKey: PARAM_IS_HEADER_MINI_APP_EXPAND,
    storageKey: PARAM_IS_HEADER_MINI_APP_EXPAND,
    envKey: '',
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  showPhoneInput: {
    paramKey: PARAM_SHOW_PHONE_INPUT,
    storageKey: PARAM_SHOW_PHONE_INPUT,
    envKey: 'REACT_APP_SHOW_PHONE_INPUT',
    defaultValue: true,
    parser: (v) => v === true || v === 1
  },
  showBannerInEmbeddedView: {
    paramKey: PARAM_SHOW_BANNER_IN_EMBEDDED_VIEW,
    storageKey: PARAM_SHOW_BANNER_IN_EMBEDDED_VIEW,
    envKey: 'REACT_APP_PARAM_SHOW_BANNER_IN_EMBEDDED_VIEW',
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  appThemeName: {
    paramKey: PARAM_APP_THEME_NAME,
    storageKey: PARAM_APP_THEME_NAME,
    envKey: 'REACT_APP_THEME_NAME',
    defaultValue: undefined,
    parser: (v) => v
  },
  isSelectVehicleTypeUseIcon: {
    paramKey: PARAM_IS_SELECT_VEHICLE_TYPE_USE_ICON,
    storageKey: PARAM_IS_SELECT_VEHICLE_TYPE_USE_ICON,
    envKey: '',
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  isTBPNSelectVehicleTypeWithElectricMotobike: {
    paramKey: PARAM_IS_TBPN_SELECT_VEHICLE_TYPE_WITH_ELECTRIC_MOTOBIKE,
    storageKey: PARAM_IS_TBPN_SELECT_VEHICLE_TYPE_WITH_ELECTRIC_MOTOBIKE,
    envKey: '',
    defaultValue: true,
    parser: (v) => v !== false && v !== 0
  },
  partnerName: {
    paramKey: PARAM_PARTNER_NAME,
    storageKey: PARAM_PARTNER_NAME,
    envKey: '',
    defaultValue: undefined,
    parser: (v) => v
  }
}

export const AppParamsContextProvider = (props) => {
  const paramsMiniApp = React.useMemo(() => {
    const params = {}

    Object.keys(PARAMS_MINIAPP_SCHEMA).forEach((key) => {
      params[key] = resolveParamsMiniApp(PARAMS_MINIAPP_SCHEMA[key])
    })

    return params
  }, [])

  // pass resolved params through context value
  return React.createElement(AppParamsContext.Provider, { value: paramsMiniApp }, props.children)
}
export const useAppParamsContext = () => {
  const context = React.useContext(AppParamsContext)
  if (!context) {
    throw new Error('useAppParamsContext must be used within AppParamsContextProvider')
  }
  return context
}
